/* PT · About page behaviour (spec-about-page-2a).
   1. Scroll-in: .pt-ab-rv elements fade/rise once, staggered ~60ms within a section.
   2. Generations timeline: autoplay every 5 s (wraps), a click restarts the countdown from
      that year; paused off-screen, while a keyboard user is on the years, when the tab
      is hidden, and never under reduced motion. The new photo fades in OVER the old one, which
      stays visible underneath until the fade ends, so the paper never flashes through. The
      text box holds a fixed height (the tallest generation), so nothing below it moves.
   3. After the page has loaded, the photos below the fold are fetched in the background. */
(function () {
  "use strict";
  /* every About section includes this file; run it once for the whole page */
  if (window.__ptAbout) return;
  window.__ptAbout = true;
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- 1 · scroll-in ---------- */
  function reveals(root) {
    var els = [].slice.call((root || document).querySelectorAll(".pt-ab-rv:not(.pt-in)"));
    if (!els.length) return;
    if (!("IntersectionObserver" in window)) { els.forEach(function (e) { e.classList.add("pt-in"); }); return; }
    var io = new IntersectionObserver(function (entries) {
      var shown = 0;
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        el.style.transitionDelay = Math.min(shown, 6) * 60 + "ms";
        shown++;
        el.classList.add("pt-in");
        io.unobserve(el);
        setTimeout(function () { el.style.transitionDelay = ""; }, 800);
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- 2 · timeline ---------- */
  function Timeline(root) {
    if (root.__ptTl) return;
    root.__ptTl = true;
    this.root = root;
    this.imgs = [].slice.call(root.querySelectorAll(".pt-ab-tl-img"));
    this.layers = [].slice.call(root.querySelectorAll(".pt-ab-tl-layer"));
    this.yrs = [].slice.call(root.querySelectorAll(".pt-ab-tl-yr"));
    this.segs = [].slice.call(root.querySelectorAll(".pt-ab-seg-btn"));
    this.seg = root.querySelector(".pt-ab-seg");
    this.fill = root.querySelector(".pt-ab-tl-fill");
    this.textBox = root.querySelector(".pt-ab-tl-text");
    this.n = this.layers.length;
    this.i = Math.max(0, Math.min(this.n - 1, parseInt(root.getAttribute("data-start") || this.n - 1, 10)));
    this.interval = (parseFloat(root.getAttribute("data-interval")) || 5) * 1000;
    this.visible = false; this.focus = false; this.timer = null;
    if (!this.n) return;
    this.bind();
    this.show(this.i, true);
    this.fitHeight();
    this.watch();
  }
  Timeline.prototype.canPlay = function () {
    return !reduce && this.visible && !this.focus && !document.hidden && this.n > 1;
  };
  Timeline.prototype.schedule = function () {
    var self = this;
    clearTimeout(this.timer);
    if (!this.canPlay()) return;
    this.timer = setTimeout(function () { self.show((self.i + 1) % self.n); self.schedule(); }, this.interval);
  };
  Timeline.prototype.pick = function (i) {
    this.show(i);
    this.schedule(); /* the countdown restarts from the chosen year */
  };
  Timeline.prototype.show = function (i, first) {
    var prev = this.i, self = this;
    this.i = i;
    /* photos: previous stays opaque underneath, the new one fades in above it */
    this.imgs.forEach(function (im, k) {
      im.classList.remove("is-on", "is-prev", "is-enter");
      if (first) { if (k === i) im.classList.add("is-on"); return; }
      if (k === prev && k !== i) im.classList.add("is-prev");
    });
    if (!first && this.imgs[i]) {
      var im = this.imgs[i];
      im.classList.add("is-on", "is-enter");
      void im.offsetWidth; /* commit opacity 0 before fading to 1 */
      im.classList.remove("is-enter");
      var done = function () { self.imgs.forEach(function (o, k) { if (k !== self.i) o.classList.remove("is-prev"); }); };
      clearTimeout(this.fadeT);
      this.fadeT = setTimeout(done, reduce ? 220 : 400);
    }
    this.layers.forEach(function (l, k) { l.classList.toggle("is-on", k === i); l.setAttribute("aria-hidden", k === i ? "false" : "true"); });
    this.yrs.forEach(function (b, k) { b.setAttribute("aria-pressed", k === i ? "true" : "false"); b.classList.toggle("is-past", k <= i); });
    this.segs.forEach(function (b, k) { b.setAttribute("aria-pressed", k === i ? "true" : "false"); });
    if (this.seg) this.seg.style.setProperty("--ab-i", i);
    this.moveFill();
  };
  Timeline.prototype.moveFill = function () {
    if (!this.fill || !this.yrs[this.i]) return;
    var dot = this.yrs[this.i].querySelector(".pt-ab-tl-dot");
    var rail = this.fill.parentNode;
    if (!dot || !rail) return;
    var r = rail.getBoundingClientRect(), d = this.yrs[this.i].getBoundingClientRect();
    /* fill runs to the active dot's centre; the active dot is 19px */
    this.fill.parentNode.style.setProperty("--ab-fill", Math.max(0, d.left - r.left + 9.5) + "px");
  };
  Timeline.prototype.fitHeight = function () {
    /* hold the text box at the tallest generation's height, so switching years never moves
       the page. CSS sets a sensible fixed height; this only ever makes it taller. */
    if (!this.textBox) return;
    this.textBox.style.height = "";
    var css = this.textBox.getBoundingClientRect().height;
    var max = 0;
    this.layers.forEach(function (l) { max = Math.max(max, l.scrollHeight); });
    var need = Math.ceil(max + 4);
    /* the CSS height is the reference size (400 desktop, 260 phones); only grow it if a
       generation's copy is ever taller, never shrink it */
    if (need > css) this.textBox.style.height = need + "px";
  };
  Timeline.prototype.bind = function () {
    var self = this;
    this.yrs.forEach(function (b, k) { b.addEventListener("click", function () { self.pick(k); }); });
    this.segs.forEach(function (b, k) { b.addEventListener("click", function () { self.pick(k); }); });
    /* keyboard: left/right move between years */
    [this.yrs, this.segs].forEach(function (list) {
      list.forEach(function (b, k) {
        b.addEventListener("keydown", function (e) {
          if (e.key !== "ArrowRight" && e.key !== "ArrowLeft") return;
          e.preventDefault();
          var j = (k + (e.key === "ArrowRight" ? 1 : -1) + self.n) % self.n;
          self.pick(j);
          if (list[j]) list[j].focus();
        });
      });
    });
    /* phones: drag or swipe along the segmented control */
    if (this.seg) {
      var dragging = false;
      var at = function (x) {
        var r = self.seg.getBoundingClientRect();
        return Math.max(0, Math.min(self.n - 1, Math.floor((x - r.left) / (r.width / self.n))));
      };
      this.seg.addEventListener("pointerdown", function (e) { dragging = true; self.seg.setPointerCapture && self.seg.setPointerCapture(e.pointerId); });
      this.seg.addEventListener("pointermove", function (e) { if (!dragging) return; var j = at(e.clientX); if (j !== self.i) self.show(j); });
      var end = function (e) { if (!dragging) return; dragging = false; self.pick(at(e.clientX)); };
      this.seg.addEventListener("pointerup", end);
      this.seg.addEventListener("pointercancel", function () { dragging = false; self.schedule(); });
    }
    /* keeps sliding under the mouse (owner: it has to auto-advance every 5 s). It pauses
       only for keyboard users working through the years; a mouse click just restarts
       the countdown, it doesn't leave the timeline stuck on focus. */
    this.root.addEventListener("focusin", function (e) {
      var kb = e.target && e.target.matches && e.target.matches(":focus-visible");
      if (!kb) return;
      self.focus = true; clearTimeout(self.timer);
    });
    this.root.addEventListener("focusout", function (e) { if (!self.root.contains(e.relatedTarget)) { self.focus = false; self.schedule(); } });
    document.addEventListener("visibilitychange", function () { self.schedule(); });
    var rt;
    window.addEventListener("resize", function () { clearTimeout(rt); rt = setTimeout(function () { self.fitHeight(); self.moveFill(); }, 120); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { self.fitHeight(); self.moveFill(); });
  };
  Timeline.prototype.watch = function () {
    var self = this;
    var eager = function () { self.imgs.forEach(function (im) { if (im.loading === "lazy") im.loading = "eager"; }); };
    if (!("IntersectionObserver" in window)) { this.visible = true; eager(); this.schedule(); return; }
    /* preload every photo well before the section arrives, so the first click shows its own photo */
    new IntersectionObserver(function (en) { if (en[0].isIntersecting) eager(); }, { rootMargin: "600px 0px" }).observe(this.root);
    new IntersectionObserver(function (en) {
      self.visible = en[0].isIntersecting;
      if (self.visible) self.schedule(); else clearTimeout(self.timer);
    }, { threshold: 0.25 }).observe(this.root);
  };

  function init(root) {
    reveals(root);
    [].slice.call((root || document).querySelectorAll("[data-ab-tl]")).forEach(function (el) { new Timeline(el); });
  }
  /* ---------- 3 · warm the photos below the fold ---------- */
  /* Once the first screen has fully loaded, fetch the rest of the page's lazy photos in page
     order, a few at a time, so they are already there when the visitor scrolls to them. The
     first paint is untouched: nothing starts until the load event and an idle moment. */
  function warm() {
    var imgs = [].slice.call(document.querySelectorAll('.pt-ab img[loading="lazy"]'));
    var k = 0;
    (function next() {
      imgs.slice(k, k + 3).forEach(function (im) { im.loading = "eager"; });
      k += 3;
      if (k < imgs.length) setTimeout(next, 150);
    })();
  }
  function afterLoad() {
    var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 200); };
    idle(warm, { timeout: 2000 });
  }
  if (document.readyState === "complete") afterLoad();
  else window.addEventListener("load", afterLoad);

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { init(); });
  else init();
  /* theme editor: re-init a section when it is added or changed */
  document.addEventListener("shopify:section:load", function (e) { init(e.target); });
})();
